import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { styled, css } from 'styled-components';
import Typography from '../../Typography';
import { CloseButton, InfoIcon, Message } from './common';
const Wrapper = styled.div `
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};
  min-height: 36px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 8px;
  border-radius: 8px;
  ${({ type, theme }) => type === 'success' &&
    css `
      background-color: ${theme.colors.positive10_2};
      border: 1px solid ${theme.colors.positive30_2};
      & ${Typography.TextMedium} {
        color: ${theme.colors.positive120_2};
      }
    `};
  ${({ type, theme }) => type === 'error' &&
    css `
      background-color: ${theme.colors.critical10_2};
      border: 1px solid ${theme.colors.critical30_2};
      & ${Typography.TextMedium} {
        color: ${theme.colors.critical120_2};
      }
    `}
  ${({ type, theme }) => (type === 'default' || type === 'info') &&
    css `
      background-color: ${theme.colors.link10_2};
      border: 1px solid ${theme.colors.link30_2};
      & ${Typography.TextMedium} {
        color: ${theme.colors.link120_2};
      }
    `}
  ${({ type, theme }) => type === 'warning' &&
    css `
      background-color: ${theme.colors.warning10_2};
      border: 1px solid ${theme.colors.warning30_2};
      & ${Typography.TextMedium} {
        color: ${theme.colors.warning120_2};
      }
    `}
  ${({ spacer }) => spacer &&
    css `
      margin-bottom: 24px;
    `};
`;
const Notification = ({ title, body, type = 'default', spacer, uncloseable, className, fullWidth, maxHeight, }) => {
    const [isVisible, setIsVisible] = useState(true);
    if (!isVisible)
        return null;
    return (_jsxs(Wrapper, { type: type, spacer: spacer, className: className, fullWidth: fullWidth, children: [_jsx(InfoIcon, { type: type }), _jsx(Message, { title: title, body: body, type: type, maxHeight: maxHeight }), !uncloseable && _jsx(CloseButton, { type: type, closeToast: () => setIsVisible(false) })] }));
};
export default Notification;
